<template>
  <div class="professional-group">
    <Header
      :right-sidebar="true"
      :right-sidebar-title="
        `Редактирование профгруппы профсоюза &quot;${unionName}&quot;`
      "
    >
      <template #right-sidebar>
        <sidebar-items-group title="Отображать столбцы">
          <fields-picker
            v-model="pickedFields"
            :fields="professionalGroupsHistoryDisplayableFields"
          />
        </sidebar-items-group>
        <sidebar-items-group title="Фильтры">
          <filters-group
            :fields="professionalGroupsHistoryFields"
            :items="professionalGroupHistory"
            v-model="filteredItems"
          />
        </sidebar-items-group>
        <sidebar-item
          button
          variant="warning"
          @click="deleteProfessionalGroup"
          :disabled="loading"
          v-if="!isDeleted"
        >
          Удалить профгруппу
          <template #icon>
            <b-icon icon="x-square" />
          </template>
        </sidebar-item>
        <sidebar-item
          button
          variant="success"
          @click="restoreProfessionalGroup"
          :disabled="loading"
          v-else
        >
          Восстановить профгруппу
          <template #icon>
            <b-icon icon="box-arrow-up-right" />
          </template>
        </sidebar-item>
        <sidebar-item
          button
          variant="danger"
          @click="showPurgeConformalModal = true"
          :disabled="loading"
        >
          Удалить профгруппу навсегда
          <template #icon>
            <b-icon icon="trash" />
          </template>
        </sidebar-item>
      </template>
    </Header>
    <Main>
      <h3 class="text-center">
        Редактирование профгруппы профсоюза "{{ unionName }}"
      </h3>
      <b-overlay :show="loading">
        <professional-group-form
          v-model="professionalGroupActualData"
          v-if="professionalGroupActualData !== undefined"
          class="professional-group__form"
        />
      </b-overlay>
    </Main>
    <Main>
      <b-overlay :show="loading">
        <h3 class="text-center">История изменений профгруппы</h3>
        <b-table
          selectable
          select-mode="single"
          :responsive="true"
          :items="paintedRows"
          :fields="pickedFields"
          hover
          class="table-rounded"
          empty-text="Записей нет"
        />
      </b-overlay>
    </Main>
    <b-modal
      centered
      title="Окончательное удаление профгруппы"
      v-model="showPurgeConformalModal"
      ok-title="Удалить"
      cancel-title="Отмена"
      ok-variant="danger"
      cancel-variant="success"
      @ok="purgeProfessionalGroup"
    >
      <p class="my-4">
        Вы точно хотите удалить эту профгруппу?<br />(История изменений
        профгруппы будет безвозвратно утеряна, кроме того, все приписанные к
        этой профгруппе люди, будут отписаны от неё)
      </p>
    </b-modal>
    <bottom-overlay v-if="edited">
      <b-button
        @click="updateProfessionalGroup"
        block
        squared
        variant="success"
        class="union__update-button"
        :disabled="loading"
      >
        Сохранить изменения
      </b-button>
      <b-button
        @click="discardChanges"
        block
        squared
        variant="warning"
        class="union__discard-changes-button"
        :disabled="loading"
      >
        Отменить изменения
      </b-button>
    </bottom-overlay>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import FieldsPicker from "@/components/Tables/FieldsPicker";
import SidebarItemsGroup from "@/components/Layout/Sidebars/SidebarItems/SidebarItemsGroup";
import FiltersGroup from "@/components/Tables/Filters/FiltersGroup";
import SidebarItem from "@/components/Layout/Sidebars/SidebarItems/SidebarItem";
import BottomOverlay from "@/components/BottomOverlay";
import { displayableFields } from "@/components/Tables/defaultFields";
import axios from "@/axios";
import Main from "@/components/Layout/Main";
import { mapActions, mapGetters } from "vuex";
import { defaultRowPainter } from "@/components/Tables/rowPainters";
import { professionalGroupsHistoryFields } from "@/views/Unions/ProfessionalGroups/models/professionalGroupsFields";
import ProfessionalGroupModel from "@/components/Forms/Union/ProfessionalGroup/models/professionalGroupModel";
import ProfessionalGroupForm from "@/components/Forms/Union/ProfessionalGroup/ProfessionalGroupForm";
import pageTitleMixin from "@/mixins/pageTitleMixin";
export default {
  components: {
    ProfessionalGroupForm,
    Main,
    BottomOverlay,
    SidebarItem,
    FiltersGroup,
    SidebarItemsGroup,
    FieldsPicker,
    Header
  },
  mixins: [pageTitleMixin],
  props: {
    unionId: {
      type: Number,
      required: true
    },
    professionalGroupId: {
      type: Number,
      required: true
    }
  },
  data() {
    let professionalGroupsHistoryDisplayableFields = displayableFields(
      professionalGroupsHistoryFields
    );
    return {
      professionalGroupsHistoryFields,
      professionalGroupsHistoryDisplayableFields,
      filteredItems: [],
      pickedFields: professionalGroupsHistoryDisplayableFields,
      professionalGroupHistory: [],
      professionalGroupActualData: undefined,
      loading: true,
      showPurgeConformalModal: false
    };
  },
  computed: {
    ...mapGetters("unions", ["unions"]),
    union: ({ unions, unionId }) =>
      unions.find(({ id }) => Number(id) === unionId),
    unionName: ({ union }) => (union !== undefined ? union.name : ""),
    isDeleted: ({ professionalGroupHistory }) =>
      professionalGroupHistory[0] !== undefined
        ? Boolean(Number(professionalGroupHistory[0].is_deleted))
        : false,
    edited: ({ professionalGroupActualData, professionalGroupHistory }) =>
      professionalGroupHistory[0] !== undefined &&
      JSON.stringify(professionalGroupActualData) !==
        JSON.stringify(new ProfessionalGroupModel(professionalGroupHistory[0])),
    paintedRows: ({ filteredItems }) => defaultRowPainter(filteredItems)
  },
  methods: {
    ...mapActions("professionalGroups", {
      loadProfessionalGroups: "loadProfessionalGroups",
      storeUpdateProfessionalGroup: "updateProfessionalGroup",
      storeDeleteProfessionalGroup: "deleteProfessionalGroup",
      storeRestoreProfessionalGroup: "restoreProfessionalGroup",
      storePurgeProfessionalGroup: "purgeProfessionalGroup"
    }),
    async updateProfessionalGroup() {
      this.loading = true;
      try {
        await this.storeUpdateProfessionalGroup({
          id: this.professionalGroupId,
          professionalGroupData: this.professionalGroupActualData
        });
        await this.loadData();
      } catch {
        this.loading = false;
      }
    },
    discardChanges() {
      this.professionalGroupActualData = new ProfessionalGroupModel(
        this.professionalGroupHistory[0]
      );
    },
    async deleteProfessionalGroup() {
      this.loading = true;
      await this.storeDeleteProfessionalGroup(this.professionalGroupId);
      await this.loadData();
    },
    async restoreProfessionalGroup() {
      this.loading = true;
      await this.storeRestoreProfessionalGroup(this.professionalGroupId);
      await this.loadData();
    },
    async purgeProfessionalGroup() {
      this.loading = true;
      await this.storePurgeProfessionalGroup(this.professionalGroupId);
      await this.$router.push(`/unions/${this.unionId}/professional-groups`);
    },
    async loadData() {
      this.professionalGroupHistory = (
        await axios.get(
          `/unions/professional-groups/${this.professionalGroupId}/history`
        )
      ).data.union_professional_group_history;
      this.professionalGroupActualData = new ProfessionalGroupModel(
        this.professionalGroupHistory[0]
      );
      this.loading = false;
    }
  },
  async created() {
    await this.loadData();
  }
};
</script>

<style lang="scss">
.professional-group {
  &__form {
    padding: 0 5px;
  }
}
</style>
